import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Space, Switch, Typography } from 'antd';
import dayjs from 'dayjs';
import Emboss, { EmbossFormInputs } from '../../Emboss/emboss';

export type FirstStepFormInputs = {
  name: string,
  // eslint-disable-next-line camelcase
  start_date: string,
  // eslint-disable-next-line camelcase
  end_date: string,
  active: boolean,
  emboss: EmbossFormInputs;
};

type FirstStepProps = {
  goToNext?: () => void | null;
  setFirstStepData?: (data: FirstStepFormInputs) => void | null;
  firstStepData?: FirstStepFormInputs | null;
  action?: string | null;
};

const FirstStep: React.FC<FirstStepProps> = ({ goToNext, setFirstStepData, firstStepData, action }) => {
  const [form] = Form.useForm();
  const [active, setActive] = useState(true);
  const [nextStep, setNextStep] = useState(false);
  const [name, setName] = useState(null);
  const [startDate, setStartDate] = useState<string>(null);
  const [endDate, setEndDate] = useState<string>(null);
  const { RangePicker } = DatePicker;
  const [submitForm, setSubmitForm] = useState<boolean>(false);

  const validateToNext = () => {
    setSubmitForm(true);
  }

  useEffect(() => {
    if(firstStepData !== null) {
      form.setFieldValue('name', firstStepData?.name);
      form.setFieldValue('active', firstStepData?.active);
    }
  }, [firstStepData]);

  return (
    <>
      <Row gutter={24}>
        <Col span={12}>
          <Typography.Title level={3} style={{ marginTop: '20px', marginBottom: '20px' }}>Datos principales</Typography.Title>
        </Col>
      </Row>
      <Form<FirstStepFormInputs>
        layout="vertical"
        form={form}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item<FirstStepFormInputs>
              name="name"
              label={'Nombre'}
              rules={[{max: 40, required: true, message: 'Por favor, ingresa un nombre.' }]}
            >
              <Input
                disabled={ action === 'view' }
                onChange={ (e) => setName(e.target.value) }
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item<FirstStepFormInputs>
              label="Fechas"
              name="start_date"
              rules={[{ required: true, message: 'Por favor, selecciona una fecha valida.' }]}
            >
              <RangePicker
                style={{ width: '100%' }}
                defaultValue={[firstStepData?.start_date && dayjs(firstStepData?.start_date, 'YYYY-MM-DD'), firstStepData?.end_date && dayjs(firstStepData?.end_date, 'YYYY-MM-DD')]}
                onChange={ (value, dateString) => {
                    setStartDate(dateString[0]);
                    setEndDate(dateString[1]);
                  }
                }
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item<FirstStepFormInputs>
              name="active"
              label="Desea inicializarlo como activo?"
              layout="horizontal"
            >
              <Checkbox checked={active} onChange={() => setActive(!active)}  />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={24}>
        {
          action === 'view' ? (
            <>
              <Col span={16}>
                <Emboss
                  emboss={ firstStepData?.emboss }
                  action={ 'view' }
                />
              </Col>
            </>
          ) : (
            <>
              <Col span={24}>
                <Emboss
                  emboss={ firstStepData?.emboss }
                  action={ 'edit' }
                  setEmboss = { (value: EmbossFormInputs) => {
                    setFirstStepData({
                      name,
                      start_date: startDate,
                      end_date: endDate,
                      active,
                      emboss: value
                    });
                    goToNext();
                  } }
                  submitForm={ submitForm }
                />
              </Col>
              <Col span={12} offset={5} style={{ textAlign: 'center' }} >
                <Space>
                  <Button type="primary" onClick={ validateToNext } >
                    Siguiente
                  </Button>
                </Space>
              </Col>
            </>
          )
        }
      </Row>
    </>
  )
}

export default FirstStep;